import React from 'react';

export const LightningIcon: React.FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.6163 1.67969C12.7585 1.50947 12.9959 1.4527 13.1993 1.54102C13.4029 1.62942 13.5237 1.84228 13.4962 2.0625L12.6368 8.93848C12.6192 9.08065 12.6631 9.22364 12.7579 9.33105C12.8528 9.43853 12.9895 9.5 13.1329 9.5H19.3282C19.5759 9.49995 19.7949 9.50007 19.9669 9.51562C20.1363 9.53096 20.3691 9.56783 20.5607 9.72266C20.7996 9.91573 20.9372 10.2075 20.9327 10.5146C20.929 10.7609 20.8077 10.9635 20.7111 11.1035C20.662 11.1746 20.6023 11.2523 20.5353 11.3359L20.3136 11.6045L11.3839 22.3203C11.2418 22.4907 11.0044 22.5473 10.8009 22.459C10.5974 22.3707 10.4767 22.1586 10.504 21.9385L11.3634 15.0625C11.3812 14.9202 11.3372 14.7765 11.2423 14.6689C11.1474 14.5615 11.0107 14.5 10.8673 14.5H4.672C4.42406 14.5 4.20448 14.5 4.03235 14.4844C3.86295 14.469 3.63004 14.433 3.4386 14.2783C3.19965 14.0852 3.06299 13.7925 3.0675 13.4854C3.07122 13.239 3.1925 13.0365 3.28918 12.8965C3.38742 12.7543 3.5279 12.5859 3.68665 12.3955L12.6163 1.67969Z"
        fill="#FFFFDA"
        stroke="#FF9200"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
